module.exports = __webpack_public_path__ + "static/img/image049.331cb80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image049.png
// module id = lBYd
// module chunks = 1